import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Hidden from '@material-ui/core/Hidden';
import Drawer from '@material-ui/core/Drawer';
// @material-ui/icons
import Menu from '@material-ui/icons/Menu';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import { userDetail } from '../../apiHelpers/user/detail';
import { ROLE_PROVIDER, ROLE_CUSTOMER } from '../../utils/config/constants';
import payment from '../../assets/images/payment.png';
import { TextField, Button } from '@material-ui/core';
const drawerWidth = 260;
const container = {
    paddingRight: '15px',
    paddingLeft: '15px',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '100%',
    '@media (min-width: 576px)': {
        maxWidth: '540px'
    },
    '@media (min-width: 768px)': {
        maxWidth: '750px'
    },
    '@media (min-width: 992px)': {
        maxWidth: '970px'
    },
    '@media (min-width: 1200px)': {
        maxWidth: '1170px'
    }
};
const styles = {
    flex: {
        flex: 1
    },

    show: {
        transform: 'translateY(0)',
        transition: 'transform .5s'
    },
    hide: {
        transform: 'translateY(-110%)',
        transition: 'transform .5s'
    },

    container: {
        ...container,
        minHeight: '50px',
        flex: '1',
        alignItems: 'center',
        justifyContent: 'space-between',
        display: 'flex',
        flexWrap: 'nowrap'
    },
    appResponsive: {
        margin: '20px 10px'
    },
    drawerPaper: {
        border: 'none',
        bottom: '0',
        transitionProperty: 'top, bottom, width',
        transitionDuration: '.2s, .2s, .35s',
        transitionTimingFunction: 'linear, linear, ease',
        width: drawerWidth,
        boxShadow:
            '0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
        position: 'fixed',
        display: 'block',
        top: '0',
        height: '100vh',
        right: '0',
        left: 'auto',
        visibility: 'visible',
        overflowY: 'visible',
        borderTop: 'none',
        textAlign: 'left',
        paddingRight: '0px',
        paddingLeft: '0',
        transition: 'all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)'
    },
    appBarTransparent: {
        marginBottom: '0',
        padding: '10px 0',
        width: '100%',
        background: 'transparent',
        boxShadow: 'none'
    },
    appBarSimple: {
        marginBottom: '0',
        padding: '0',
        width: '100%',
        boxShadow:
            '0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)'
    }
};

let isMounted = false;

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileOpen: false,
            isTransparent: true,
            city: '',
            serviceName: ''
        };
        this.lastScroll = null;
        this.handleScroll = this.handleScroll.bind(this);
        this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
        this.headerColorChange = this.headerColorChange.bind(this);
        this.handleDrawerClose = this.handleDrawerClose.bind(this);
    }
    handleDrawerToggle() {
        this.setState({ mobileOpen: !this.state.mobileOpen });
    }
    handleDrawerClose() {
        this.setState({ mobileOpen: false });
    }
    componentDidMount() {
        isMounted = true;
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        if (isMounted) {
            if (this.props.changeColorOnScroll) {
                window.addEventListener('scroll', this.headerColorChange);
            }
        }
    }

    headerColorChange() {
        const { changeColorOnScroll } = this.props;
        const windowsScrollTop = window.pageYOffset;
        if (windowsScrollTop > changeColorOnScroll.height) {
            this.setState({ isTransparent: false });
        } else {
            this.setState({ isTransparent: true });
        }
    }

    handleScroll(evt) {
        const lastScroll = window.scrollY;
        if (lastScroll === this.lastScroll) {
            return;
        }

        const shouldShow =
            this.lastScroll !== null ? lastScroll < this.lastScroll : null;
        if (shouldShow !== this.state.shouldShow) {
            this.setState((prevState, props) => ({
                ...prevState,
                shouldShow
            }));
        }
        this.lastScroll = lastScroll;
    }

    componentWillUnmount() {
        isMounted = false;
        if (this.props.changeColorOnScroll) {
            window.removeEventListener('scroll', this.headerColorChange);
            window.removeEventListener('scroll', this.handleScroll);
        }
    }
    renderSignin = () => {
        this.props.history.push({ pathname: `/user/signin` });
    };
    renderRegister = () => {
        this.props.history.push({ pathname: `/signup` });
    };
    renderHomePage = () => {
        this.props.history.push(`/`);
    };
    renderDashboard = userData => {
        if (userData.role == ROLE_PROVIDER) {
            this.props.history.push(`/user/dashboard`);
        } else {
            this.props.history.push(`/user/profile`);
        }
    };
    redirectCMS = link => {
        this.props.history.push('/page/' + link.slug);
    };
    redirectSignin = () => {
        this.props.history.push(`/user/signin`);
    };
    redirectRegister = () => {
        this.props.history.push(`/signup`);
    };
    redirectCategory = categoryId => {
        this.props.history.push({
            pathname: `/category/services/`,
            state: { itemId: categoryId }
        });
    };
    searchProvider = () => {
        this.props.history.push({
            pathname: `/provider/list/${
                this.state.serviceName ? this.state.serviceName : 'none'
            }/${this.state.city ? this.state.city : 'none'}/${'none'}`
        });
        window.location.reload();
    };

    render() {
        const {
            classes,
            rightLinks,
            leftLinks,
            brand,
            brandImg,
            userData
        } = this.props;
        const { isTransparent } = this.state;
        const brandComponent = (
            <span className={'home-logo'} onClick={this.renderHomePage}>
                {brandImg && (
                    <img
                        width="auto"
                        height="35px"
                        src={brandImg}
                        alt={'logo'}
                    />
                )}
                {brand && <h2>{brand}</h2>}
            </span>
        );

        return (
            <div>
                <AppBar
                    className={
                        isTransparent
                            ? classes.appBarTransparent +
                              ' ' +
                              classes.show +
                              ' header-links-menu'
                            : classes.appBarSimple +
                              ' ' +
                              classes.hide +
                              ' header-links-menu'
                    }
                >
                    <div className="container">
                        <div className="d-flex align-items-center">
                            {leftLinks !== undefined ? brandComponent : null}
                            <div className={classes.flex}>
                                {leftLinks !== undefined ? (
                                    <Hidden smDown implementation="css">
                                        {leftLinks}
                                    </Hidden>
                                ) : (
                                    brandComponent
                                )}
                            </div>
                            <Hidden smDown implementation="css">
                                {rightLinks}
                            </Hidden>
                            <Hidden mdUp>
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    onClick={this.handleDrawerToggle}
                                >
                                    <Menu />
                                </IconButton>
                            </Hidden>
                        </div>
                    </div>
                    <Hidden mdUp implementation="css">
                        <Drawer
                            variant="temporary"
                            anchor={'right'}
                            open={this.state.mobileOpen}
                            classes={{
                                paper: classes.drawerPaper + ' sidebar-menus'
                            }}
                            onClose={this.handleDrawerClose}
                        >
                            <div
                                className={classes.appResponsive}
                                onClick={this.handleDrawerClose}
                                onKeyDown={this.handleDrawerClose}
                            >
                                {leftLinks}
                                {rightLinks}
                            </div>
                        </Drawer>
                    </Hidden>
                </AppBar>

                <AppBar
                    className={
                        isTransparent
                            ? classes.appBarTransparent +
                              ' ' +
                              classes.hide +
                              ' header-links-menu'
                            : classes.appBarSimple +
                              ' ' +
                              classes.show +
                              ' header-links-menu'
                    }
                >
                    <div>
                        <div className="container top-search-main">
                            <div className="row dflex-inherit d-inherit">
                                <div className="ts-menu">
                                    <div
                                        className="ts-menu-1"
                                        onClick={this.renderHomePage}
                                    >
                                        {brandImg && (
                                            <img
                                                width="auto"
                                                height="35px"
                                                src={brandImg}
                                                alt={'logo'}
                                            />
                                        )}
                                        {brand && <h2>{brand}</h2>}
                                    </div>

                                    <div className="ts-menu-2 menu-hover">
                                        <a href="#" className="t-bb">
                                            <FormattedMessage
                                                id="menu"
                                                defaultValue="Menu"
                                            />
                                            <i
                                                className="fa fa-angle-down"
                                                aria-hidden="true"
                                            />
                                        </a>

                                        <div className="cat-menu cat-menu-1">
                                            <div className="dz-menu">
                                                <div className="dz-menu-inn">
                                                    <h4>
                                                        <FormattedMessage
                                                            id="pages"
                                                            defaultValue="Pages"
                                                        />
                                                    </h4>
                                                    <ul>
                                                        {this.props.cmsLinks &&
                                                            this.props.cmsLinks.map(
                                                                (
                                                                    link,
                                                                    index
                                                                ) => {
                                                                    return (
                                                                        <li
                                                                            style={{
                                                                                cursor:
                                                                                    'pointer'
                                                                            }}
                                                                            key={
                                                                                index
                                                                            }
                                                                        >
                                                                            <a
                                                                                onClick={() =>
                                                                                    this.redirectCMS(
                                                                                        link
                                                                                    )
                                                                                }
                                                                            >
                                                                                {
                                                                                    link.title
                                                                                }
                                                                            </a>
                                                                        </li>
                                                                    );
                                                                }
                                                            )}
                                                    </ul>
                                                </div>
                                                <div className="dz-menu-inn">
                                                    <h4>
                                                        <FormattedMessage
                                                            id="topCategories"
                                                            defaultValue="Top Categories"
                                                        />
                                                    </h4>
                                                    <ul>
                                                        {this.props.categoryData.map(
                                                            (link, index) => {
                                                                return (
                                                                    <li
                                                                        style={{
                                                                            cursor:
                                                                                'pointer'
                                                                        }}
                                                                        key={
                                                                            index
                                                                        }
                                                                    >
                                                                        <a
                                                                            onClick={() =>
                                                                                this.redirectCategory(
                                                                                    link.id
                                                                                )
                                                                            }
                                                                        >
                                                                            {
                                                                                link.heading
                                                                            }
                                                                        </a>
                                                                    </li>
                                                                );
                                                            }
                                                        )}
                                                    </ul>
                                                </div>

                                                <div className="dir-home-nav-bot">
                                                    <ul>
                                                        <li>
                                                            <FormattedMessage
                                                                id="fewReasons"
                                                                defaultValue="A few reasons you’ll love Us"
                                                            />
                                                            <span>
                                                                <FormattedMessage
                                                                    id="callOnUs"
                                                                    defaultValue="Call us on"
                                                                />
                                                                : +01 6214 6548
                                                            </span>{' '}
                                                        </li>
                                                        {userData.name != '' &&
                                                            userData.role ==
                                                                ROLE_PROVIDER && (
                                                                <React.Fragment>
                                                                    <li>
                                                                        <a
                                                                            onClick={
                                                                                this
                                                                                    .redirectDashboard
                                                                            }
                                                                            className="waves-effect waves-light btn-large"
                                                                        >
                                                                            <i className="fa fa-bullhorn" />{' '}
                                                                            <FormattedMessage
                                                                                id="dashboard"
                                                                                defaultValue="Dashboard"
                                                                            />
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a
                                                                            onClick={
                                                                                this
                                                                                    .redirectAddService
                                                                            }
                                                                            className="waves-effect waves-light btn-large"
                                                                        >
                                                                            <i className="fa fa-bullhorn" />{' '}
                                                                            <FormattedMessage
                                                                                id="addService"
                                                                                defaultValue="Add Service"
                                                                            />
                                                                        </a>
                                                                    </li>
                                                                </React.Fragment>
                                                            )}
                                                        {userData.name != '' &&
                                                            userData.role ==
                                                                ROLE_CUSTOMER && (
                                                                <React.Fragment>
                                                                    <li>
                                                                        <a
                                                                            onClick={
                                                                                this
                                                                                    .providerListing
                                                                            }
                                                                            className="waves-effect waves-light btn-large"
                                                                        >
                                                                            <i className="fa fa-bullhorn" />{' '}
                                                                            <FormattedMessage
                                                                                id="allProviders"
                                                                                defaultValue="All Providers"
                                                                            />
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a
                                                                            onClick={
                                                                                this
                                                                                    .redirectUserProfile
                                                                            }
                                                                            className="waves-effect waves-light btn-large"
                                                                        >
                                                                            <i className="fa fa-bullhorn" />{' '}
                                                                            <FormattedMessage
                                                                                id="myProfile"
                                                                                defaultValue="My Profile"
                                                                            />
                                                                        </a>
                                                                    </li>
                                                                </React.Fragment>
                                                            )}
                                                        {userData.name ==
                                                            '' && (
                                                            <React.Fragment>
                                                                <li>
                                                                    <a
                                                                        onClick={
                                                                            this
                                                                                .redirectSignin
                                                                        }
                                                                        className="waves-effect waves-light btn-large"
                                                                    >
                                                                        <i className="fa fa-lock" />{' '}
                                                                        <FormattedMessage
                                                                            id="signin"
                                                                            defaultValue="Signin"
                                                                        />
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a
                                                                        onClick={
                                                                            this
                                                                                .redirectRegister
                                                                        }
                                                                        className="waves-effect waves-light btn-large"
                                                                    >
                                                                        <i className="fa fa-user" />{' '}
                                                                        <FormattedMessage
                                                                            id="register"
                                                                            defaultValue="Register"
                                                                        />
                                                                    </a>
                                                                </li>
                                                            </React.Fragment>
                                                        )}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ts-menu-3">
                                        <div className="">
                                            <form className="tourz-search-form tourz-top-search-form">
                                                <div className="input-field">
                                                    <input
                                                        type="text"
                                                        id="top-select-search"
                                                        className="autocomplete select-city"
                                                        onChange={event => {
                                                            this.setState({
                                                                city:
                                                                    event.target
                                                                        .value
                                                            });
                                                        }}
                                                        placeholder={this.props.intl.formatMessage(
                                                            { id: 'enterCity' }
                                                        )}
                                                    />

                                                    <ul className="autocomplete-content dropdown-content" />
                                                </div>
                                                <div className="input-field">
                                                    <input
                                                        type="text"
                                                        id="top-select-search"
                                                        className="autocomplete city-select"
                                                        onChange={event => {
                                                            this.setState({
                                                                serviceName:
                                                                    event.target
                                                                        .value
                                                            });
                                                        }}
                                                        placeholder={this.props.intl.formatMessage(
                                                            {
                                                                id:
                                                                    'searchMessage'
                                                            }
                                                        )}
                                                    />

                                                    <ul className="autocomplete-content dropdown-content" />
                                                </div>
                                                <div className="input-field">
                                                    <Button
                                                        className="waves-button-input waves-effect waves-light tourz-top-sear-btn waves-input-wrapper"
                                                        onClick={() => {
                                                            this.searchProvider();
                                                        }}
                                                    >
                                                        Search
                                                    </Button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    {!userData.name ? (
                                        <div className="ts-menu-4">
                                            <div className="v3-top-ri">
                                                <ul>
                                                    <li
                                                        onClick={() =>
                                                            this.renderSignin()
                                                        }
                                                    >
                                                        <a className="v3-menu-sign">
                                                            <i className="fa fa-sign-in" />
                                                            <FormattedMessage
                                                                id="signin"
                                                                defaultMessage="Sign In"
                                                            />
                                                        </a>
                                                    </li>
                                                    <li
                                                        onClick={() =>
                                                            this.renderRegister()
                                                        }
                                                    >
                                                        <a className="v3-add-bus">
                                                            <i className="fa fa-user" />
                                                            <FormattedMessage
                                                                id="register"
                                                                defaultMessage="Register"
                                                            />
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="ts-menu-4">
                                            <div className="v3-top-ri">
                                                <ul>
                                                    <li
                                                        onClick={userData =>
                                                            this.renderDashboard(
                                                                userData
                                                            )
                                                        }
                                                    >
                                                        <a className="v3-add-bus">
                                                            <i className="fa fa-user" />
                                                            <FormattedMessage
                                                                id="header.dashboard"
                                                                defaultMessage="Dashboard"
                                                            />
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    )}

                                    <div className="ts-menu-5">
                                        <span>
                                            <i
                                                className="fa fa-bars"
                                                aria-hidden="true"
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </AppBar>
            </div>
        );
    }
}

Header.defaultProp = {
    color: 'white'
};

Header.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf([
        'primary',
        'info',
        'success',
        'warning',
        'danger',
        'transparent',
        'white',
        'rose',
        'dark'
    ]),
    rightLinks: PropTypes.node,
    leftLinks: PropTypes.node,
    brand: PropTypes.string,
    fixed: PropTypes.bool,
    absolute: PropTypes.bool,

    changeColorOnScroll: PropTypes.shape({
        height: PropTypes.number.isRequired,
        color: PropTypes.oneOf([
            'primary',
            'info',
            'success',
            'warning',
            'danger',
            'transparent',
            'white',
            'rose',
            'dark'
        ]).isRequired
    })
};

const mapStateToProps = ({ settings, auth, categories }) => {
    return {
        cmsLinks: settings.cmsLinks,
        userData: auth.userData,
        categoryData: categories.categoryData
    };
};
const composedComponent = compose(
    connect(
        mapStateToProps,
        actions
    )
);

export default composedComponent(
    withRouter(injectIntl(withStyles(styles)(Header)))
);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx